import { RouteInterface } from '@/src/common/enums/routes'
import { RewardsTab } from './tab'

export const RewardsRoutes = {
  Rewards: {
    route: `/main/(tabs)/${RewardsTab['rewards'].name}/rewards`,
    name: RewardsTab['rewards'].name,
    availableForDeepLinking: true,
    aliases: [`/main/${RewardsTab['rewards'].name}`],
  },
  PointsLedger: {
    route: `/main/(tabs)/${RewardsTab['rewards'].name}/points-ledger`,
    name: RewardsTab['rewards'].name,
    availableForDeepLinking: true,
    aliases: [`/main/${RewardsTab['rewards'].name}/points-ledger`],
  },
  PointsTransferInterstitial: {
    route: `/main/(tabs)/${RewardsTab['rewards'].name}/points-transfer`,
    name: RewardsTab['rewards'].name,
    availableForDeepLinking: false,
    aliases: [`/main/${RewardsTab['rewards'].name}/points-transfer`],
  },
} as const satisfies Record<string, RouteInterface>
